import { Chip, Tooltip } from "@mui/material";
import React from "react";
import { DateAndTimeGridCell } from "../common/DateAndTimeGridCell";

const TIMEZONE = {
    UTC: "UTC",
    LOCAL: "LOCAL",
};

const formatDate = (value, tz) => {
    if (!value) return "-";
    const date = new Date(value);
    if (isNaN(date)) return "-";
    const opts = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
    };
    if (tz === TIMEZONE.UTC) {
        return date.toLocaleString("en-GB", { ...opts, timeZone: "UTC" }) + " UTC";
    }
    return date.toLocaleString("en-GB", opts);
};

const getColumnsData = (tz) => {
    return [
        {
            field: "subscriptionAccountingId",
            headerName: "Acct. ID",
            flex: 2,
            sortable: false,
            renderCell: (data) => (
                <Tooltip title={data?.value}>
                    <p style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                        {data?.value || "-"}
                    </p>
                </Tooltip>
            ),
        },
        {
            field: "serialNo",
            headerName: "Serial No.",
            flex: 1.5,
            sortable: false,
            renderCell: (data) => (
                <Tooltip title={data?.value}>
                    <p style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                        {data?.value || "-"}
                    </p>
                </Tooltip>
            ),
        },
        {
            field: "vehicleKey",
            headerName: "Vehicle Key",
            flex: 2,
            sortable: false,
            renderCell: (data) => (
                <Tooltip title={data?.value}>
                    <p style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                        {data?.value || "-"}
                    </p>
                </Tooltip>
            ),
        },
        {
            field: "transactionId",
            headerName: "Transaction ID",
            flex: 1,
            sortable: false,
            renderCell: (data) => (
                <Tooltip title={data?.value}>
                    <p style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                        {data?.value || "-"}
                    </p>
                </Tooltip>
            ),
        },
        {
            field: "pos",
            headerName: "POS",
            flex: 0.5,
            sortable: false,
            renderCell: (data) => (
                <Tooltip title={data?.value}>
                    <p style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                        {data?.value || "-"}
                    </p>
                </Tooltip>
            ),
        },
        {
            field: "subscriptionUpdateMethod",
            headerName: "Update Method",
            flex: 1,
            sortable: false,
            renderCell: (data) => (
                <Tooltip title={data?.value}>
                    <p style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                        {data?.value || "-"}
                    </p>
                </Tooltip>
            ),
        },
        {
            field: "daysAddedOrRemoved",
            headerName: "Days +/-",
            flex: 0.5,
            type: "number",
            renderCell: (data) => {
                const value = data?.value;
                if (value == null) return "-";
                const color = value > 0 ? "success" : value < 0 ? "error" : "default";
                return (
                    <Chip
                        label={value > 0 ? `+${value}` : `${value}`}
                        color={color}
                        size="small"
                        variant="outlined"
                    />
                );
            },
        },
        {
            field: "subscriptionStartDate",
            headerName: "Sub. Start",
            type: "dateTime",
            flex: 1.25,
            valueGetter: (data) => data?.row?.subscriptionStartDate
                ? new Date(data.row.subscriptionStartDate)
                : null,
            valueFormatter: ({ value }) => value ? formatDate(value, tz) : "-",
            renderCell: (data) => formatDate(data?.row?.subscriptionStartDate, tz),
        },
        {
            field: "subscriptionEndDate",
            headerName: "Sub. End",
            flex: 1.25,
            type: "dateTime",
            valueGetter: (data) => data?.row?.subscriptionEndDate
                ? new Date(data.row.subscriptionEndDate)
                : null,
            valueFormatter: ({ value }) => value ? formatDate(value, tz) : "-",
            renderCell: (data) => formatDate(data?.row?.subscriptionEndDate, tz),
        },
        {
            field: "createdAt",
            headerName: "Created At",
            flex: 1.25,
            type: "dateTime",
            valueGetter: (data) => data?.row?.createdAt
                ? new Date(data.row.createdAt)
                : null,
            valueFormatter: ({ value }) => value ? formatDate(value, tz) : "-",
            renderCell: (data) => formatDate(data?.row?.createdAt, tz),
        },
    ];
};

export { getColumnsData, TIMEZONE };